// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { scopes as tableScopes } from '../../../../constants/scopes';
import colours from '../../../../constants/colours';
import CombinedStatsDonut from '../../../common/CombinedStatsDonut';

const TerritoryStats = ({ id, stats }) => {
  const [_stats, _setStats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (stats) {
      _setStats([
        {
          colour: colours.STATS_ALLOWED_SKUS,
          linkto: `/games?${tableScopes.ALLOWEDTERRITORY}=${id}&groupBy=sku`,
          title: 'Allowed SKUs',
          metric: stats.allowedSkuCount,
          primaryStat: true,
        },
        {
          colour: colours.STATS_DISALLOWED_SKUS,
          linkto: `/games?${tableScopes.DISALLOWEDTERRITORY}=${id}&groupBy=sku`,
          title: 'Disallowed SKUs',
          metric: stats.disallowedSkuCount,
        },
        {
          colour: colours.STATS_USERS_WITH_TERRITORY,
          linkto: `/users?${tableScopes.HASTERRITORY}=${id}`,
          title: 'Users with territory',
          metric: stats.usersWithTerritoryCount,
        },
      ]);
    }
  }, [id, stats]);
  return (
    <div className="d-flex overflow-hidden flex-column flex-xl-row">
      <CombinedStatsDonut stats={_stats} />
    </div>
  );
};

export default TerritoryStats;
